import * as React from 'react'
import { connect } from 'react-redux'
import { SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import If from './If'

interface IfCountryProps {
  children: any | any[]
  country: SiteCountry | SiteCountry[]
  currentCountry: SiteCountry
}

export const IfCountry: React.FC<IfCountryProps> = (props: IfCountryProps) => {
  const { children, country, currentCountry } = props
  if (country instanceof Array) {
    return (
      <If condition={(country as SiteCountry[]).indexOf(currentCountry) >= 0}>
        {children}
      </If>
    )
  }
  return <If condition={country === currentCountry}>{children}</If>
}

export default connect((state: AppState) => ({
  currentCountry: state.locale.country,
}))(IfCountry)
